import React from 'react';
import classnames from 'classnames';
import './SearchItem.scss';
import { SearchEntity } from 'v2/models';
import { Columns } from 'v2/utils/searchViewUtils';
import angleIcon from 'v2/icons/angle.svg';
import { Card } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import columnByType from './Columns';
import ReviewerButtons from './Buttons/ReviewerButtons';
import { FreeUserBeacon } from 'v2/common/FreeUserBeacon/FreeUserBeacon';
import { useInvalidateSearchCounts } from 'v2/queries/searches/useInvalidateSearchCounts';
import SearchBadDescription from 'v2/common/SearchBadDescription/SearchBadDescription';

interface SearchItemProps {
  columns: Columns;
  search: SearchEntity;
  showForReviewButton?: boolean;
  refetch?: () => void;
}

export const SearchItem = ({
  search,
  columns,
  showForReviewButton,
  refetch,
}: SearchItemProps) => {
  const location = useLocation();
  const listType = location.pathname?.includes('/reviewer/')
    ? 'reviewer'
    : 'requester';

  const invalidateSearchCounts = useInvalidateSearchCounts();

  return (
    <div className="position-relative">
      <FreeUserBeacon />
      <Link
        key={search.id}
        className="text-decoration-none"
        role="listitem"
        to={{
          pathname: `/${listType}/request-details/${search.id}/detail`,
          state: { counterToGoBack: -1, comingFromPath: location.pathname },
        }}
        data-cy="requests:requests-in-list"
      >
        <Card className="mb-3">
          <Card.Body className={classnames('row-body')}>
            <div
              className={classnames(
                'search-row',
                `search-col-${columns.length}`
              )}
            >
              {columns.map((options) => {
                const Column = columnByType[options.type];
                return (
                  <Column
                    key={options.type}
                    search={search}
                    options={options}
                  />
                );
              })}
            </div>
            <div className={classnames('next-link')}>
              <img src={angleIcon} alt="angleIcon"></img>
            </div>
            {showForReviewButton && refetch && (
              <div className="d-flex align-items-center">
                <ReviewerButtons
                  search={search}
                  refetchFunction={() => {
                    refetch();
                    invalidateSearchCounts();
                  }}
                />
                <SearchBadDescription search={search} />
              </div>
            )}
          </Card.Body>
        </Card>
      </Link>
    </div>
  );
};
